import { useAppTheme } from "../../../hooks/useAppTheme";
import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";

import { Bar, Line } from "react-chartjs-2";
import { ScrollView } from "react-native-gesture-handler";
import { useSelector } from "react-redux";
import type { ThemeColors } from "../../../utils/constants/colors";

// Dummy Chart Data
const chartData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Orders",
      data: [65, 59, 80, 81, 56, 55, 40],
      backgroundColor: "rgba(75,192,192,0.2)",
      borderColor: "rgba(75,192,192,1)",
      borderWidth: 1,
    },
  ],
};

const revenueData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Revenue",
      data: [5000, 7000, 8000, 6000, 7500, 9000, 8500],
      backgroundColor: "rgba(255,99,132,0.2)",
      borderColor: "rgba(255,99,132,1)",
      borderWidth: 1,
    },
  ],
};

const AdminDashboardScreen = () => {
  const { colors } = useAppTheme();
  const styles = createStyles(colors);

  return (
    <ScrollView contentContainerStyle={{ flex: 1, padding: 20 }}>
      <Text style={styles.dashboardText}>Welcome to the Admin Dashboard</Text>

      {/* Chart Section */}
      <View style={styles.chartContainer}>
        <Text style={styles.chartTitle}>Orders Overview</Text>
        <Bar
          data={chartData}
          width={Dimensions.get("window").width - 30}
          height={220}
          options={{ responsive: true }}
        />
      </View>

      <View style={styles.chartContainer}>
        <Text style={styles.chartTitle}>Revenue Overview</Text>
        <Line
          data={revenueData}
          width={Dimensions.get("window").width - 30}
          height={220}
          options={{ responsive: true }}
        />
      </View>
    </ScrollView>
  );
};

function createStyles(colors: ThemeColors) {
  return StyleSheet.create({
    content: {
      justifyContent: "flex-start",
      alignItems: "center",
      padding: 20,
    },
    dashboardText: {
      fontSize: 24,
      fontWeight: "bold",
      marginBottom: 20,
    },
    chartContainer: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: colors.surface,
      borderRadius: 10,
      padding: 20,
      marginBottom: 20,
    },
    chartTitle: {
      fontSize: 20,
      marginBottom: 10,
      fontWeight: "bold",
    },
    closeButton: {
      alignSelf: "flex-end",
      padding: 10,
      marginRight: 10,
    },
  });
}

export default AdminDashboardScreen;
